<script>
  import { _ } from 'svelte-i18n';

  function toggleFontSize() {
    window.document.body.parentElement.classList.toggle('large-fonts')
  }

  function toggleHighContrast() {
    let theme = window.document.body.parentElement.getAttribute('data-theme');

    if (theme == 'dark')
      window.document.body.parentElement.setAttribute('data-theme', '');
    else
      window.document.body.parentElement.setAttribute('data-theme', 'dark');
  }
</script>

<div>

  <div class="flex flex-col">
    <!--! Icons from Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->

    <div class="my-2">
      <button class="btn btn-circle btn-secondary shadow-md mr-4 align-middle" on:click={toggleFontSize}>
        <svg class="w-6 h-6 fill-secondary-content" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H160 32zm470.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"/></svg>
      </button>
      Increase Font Size
    </div>

    <div class="my-2">
      <button class="btn btn-circle btn-secondary shadow-md mr-4 align-middle" on:click={toggleHighContrast}>
        <svg class="w-6 h-6 fill-secondary-content" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"/></svg>
      </button>
      High Contrast
    </div>
  </div>

</div>

<style lang="scss">
  :global(html.large-fonts) {
    font-size: 1.5rem;
  }
</style>